import gsap from "gsap";
import { addTableRecord } from "../../utils/api/tableApi";

export const ADD_INITIAL_FORM = {
  Kampania: "",
  Klient: "",
  Link: "",
  Format: "",
  Kategoria: "",
};

const INFO_TYPE_SUCCESS = "Succes";
const INFO_TYPE_FAIL = "Fail";

const INFO_ADD_SUCCESS = "Udalo sie dodac!";
const INFO_ADD_FAIL = "Nie udalo sie dodac!";
const MISSING_DATA_MESSAGE = "Nie podano wszystkich danych!";

const hasRequiredData = (formData) =>
  Boolean(
    formData.Kampania &&
      formData.Klient &&
      formData.Link &&
      formData.Format &&
      formData.Kategoria
  );

export const hideAddModal = (modalRef) => {
  if (!modalRef?.current) return;

  gsap.to(modalRef.current, {
    opacity: 0,
    duration: 0.3,
    onComplete: () => {
      modalRef.current.style.display = "none";
      gsap.set(modalRef.current, { opacity: 1 });
    },
  });
};

export function createAddController({
  choosenTable,
  getData,
  setInfoType,
  setInfo,
  setFormData,
  modalRef,
}) {
  const clearForm = () => setFormData(ADD_INITIAL_FORM);

  const submitForm = async (formData) => {
    if (!hasRequiredData(formData)) {
      alert(MISSING_DATA_MESSAGE);
      return false;
    }

    try {
      const response = await addTableRecord(choosenTable, formData);

      if (response.status === 200) {
        await getData();
        hideAddModal(modalRef);
        clearForm();
        setInfoType(INFO_TYPE_SUCCESS);
        setInfo(INFO_ADD_SUCCESS);
        return true;
      }

      setInfoType(INFO_TYPE_FAIL);
      setInfo(INFO_ADD_FAIL);
      return false;
    } catch (error) {
      console.error(error);
      setInfoType(INFO_TYPE_FAIL);
      setInfo(INFO_ADD_FAIL);
      return false;
    }
  };

  return {
    clearForm,
    submitForm,
  };
}
